module.exports = __webpack_public_path__ + "img/home-banner@0.33x.639510b4.jpg";